import React, { lazy, Suspense } from 'react';

const LazyDailyDTRNoReview = lazy(async () => await import('./DailyDTRNoReview'));

const DailyDTRNoReview = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyDailyDTRNoReview {...props} />
  </Suspense>
);

export default DailyDTRNoReview;
